/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FoldersRefetchWrapper_viewer$ref = any;
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosSortByTypes = "ALPHABETICAL" | "CREATED" | "CUSTOM" | "MODIFIED" | "%future added value";
export type FoldersRefetchWrapperRefetchQueryVariables = {
    readonly after?: string | null;
    readonly first: number;
    readonly foldersSort?: PortfoliosSortByTypes | null;
    readonly portfolioTypes?: ReadonlyArray<PortfolioTypes | null> | null;
    readonly userIds: ReadonlyArray<string | null>;
    readonly hasUserId: boolean;
    readonly page: number;
};
export type FoldersRefetchWrapperRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FoldersRefetchWrapper_viewer$ref;
    } | null;
};
export type FoldersRefetchWrapperRefetchQuery = {
    readonly response: FoldersRefetchWrapperRefetchQueryResponse;
    readonly variables: FoldersRefetchWrapperRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "after",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "foldersSort",
            "type": "PortfoliosSortByTypes",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "portfolioTypes",
            "type": "[PortfolioTypes]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any),
        ({
            "kind": "Variable",
            "name": "portfolioTypes",
            "variableName": "portfolioTypes"
        } as any),
        ({
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "foldersSort"
        } as any),
        ({
            "kind": "Variable",
            "name": "userIds",
            "variableName": "userIds"
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalResults",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "numberOfPages",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FoldersRefetchWrapperRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FoldersRefetchWrapper_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "FoldersRefetchWrapperRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "foldersPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v5 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "cursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "serviceId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "name",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "items",
                                                            "storageKey": "items(first:4,sortBy:\"CUSTOM\")",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 4
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "sortBy",
                                                                    "value": "CUSTOM"
                                                                }
                                                            ],
                                                            "concreteType": "PortfolioItemsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "pageInfo",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "startCursor",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v5 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PortfolioItemsEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "PortfolioItemV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "item",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Item",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "photos",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ItemPhoto",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "alias": null,
                                                                                                    "name": "versions",
                                                                                                    "storageKey": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "ItemPhotoVersion",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "alias": null,
                                                                                                            "name": "webPath",
                                                                                                            "args": null,
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                (v1 /*: any*/)
                                                                                            ]
                                                                                        },
                                                                                        (v1 /*: any*/)
                                                                                    ]
                                                                                },
                                                                                (v1 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": "foldersPortfolios",
                                    "name": "portfolios",
                                    "args": (v2 /*: any*/),
                                    "handle": "connection",
                                    "key": "FoldersRefetchWrapper_foldersPortfolios",
                                    "filters": [
                                        "portfolioTypes",
                                        "sortBy",
                                        "userIds",
                                        "page"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "FoldersRefetchWrapperRefetchQuery",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/FoldersRefetchWrapperRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '0879c75410c041ac156c2c96692e1108';
export default node;
